export default{
  "/":"panel",
  "/panel":"logExpense",
  "/cost":"expenseMonitoring",
  "/requests":"managerApproval",
  "/accounting":"accountingApproval",
  "/reports":"reports",
  "/help":"help"
}
